import script from "./InfoBuilding.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoBuilding.vue?vue&type=script&setup=true&lang=js"

import "./InfoBuilding.vue?vue&type=style&index=0&id=64f072b1&lang=css"

const __exports__ = script;

export default __exports__